// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2tb3U","col":"styles_col__1v2QU"};